import React , {useRef , useState } from 'react'
import { Link } from 'react-router-dom'
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger, SplitText } from "gsap/all";
import "react-international-phone/style.css";
import { toast, ToastContainer } from "react-toastify";

import { useForm, Controller } from "react-hook-form";
import { PhoneInput } from "react-international-phone";
gsap.registerPlugin(ScrollTrigger, SplitText);
const apiData =
"https://script.google.com/macros/s/AKfycbzymZo1ldj_EnJrHrygb5JYbnhC3hWfPJgEvruFuiusq41cdjw3hqQEoa1EWGU-gnlBFQ/exec";
const ContactInner = () => {
    const [phone, setPhone] = useState("");
    const container = useRef();
    const container2 = useRef();
  const [successm, setSuccessm] = useState(false);
  const [message, setMessage] = useState({
    type: "success",
    info: "Form submission failed. Please try again.",
  });
  const [btnDisabled, setBtnDisabled] = useState(false);
  const {
    register,
    control,
    handleSubmit,
    trigger,
    formState: { errors, isValid, isSubmitted },
    watch,
  } = useForm({
    mode: "onBlur",
  });
  const formHandlerSubmit = async (e) => {
    e.preventDefault();
    const valid = await trigger();
    if (!valid) {
      setBtnDisabled(false);
      return;
    }
    setBtnDisabled(true);

    const f = e.target;
    const data = new FormData(f);
    const formData = Object.fromEntries(data);
    const createdby = new Date();
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    const formattedDate = createdby.toLocaleString("en-US", options);
    formData.CreatedDate = formattedDate;

    try {
      const response = await fetch(apiData, {
        method: "POST",
        body: JSON.stringify(formData),
      });

      f.reset();
      setPhone("");
      if (response.ok) {
        toast.success("Form submitted successfully!");
      } else {
        toast.error("Submission failed. Try again.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }

    setSuccessm(true);

    setTimeout(() => {
      setSuccessm(false);
      setBtnDisabled(false);
      setMessage("");
    }, 3000);
  };
      useGSAP(
    () => { 

      // let split = SplitText.create(".content_para_animation", {
      //   type: "words,chars,lines",
      // });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top+=250 bottom",
          end: "bottom",
          // markers: true
        },
      });
      
       tl.fromTo(
          container.current,
          { opacity: 0, y: 80 },
          {
            opacity: 1,
            y: 0,
            duration: 0.5,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }, 
        ).fromTo(
          ".contact_address_animation",
          { opacity: 0, y: 60 },
          {
            opacity: 1,
            y: 0,
            duration: 0.9,
            stagger: 0.2,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }, "0"
        )
      return () => {
        tl.kill();
      };
    },
    { scope: container },
  );
     useGSAP(
    () => {

      // let split = SplitText.create(".content_para_animation", {
      //   type: "words,chars,lines",
      // });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container2.current,
          start: "top+=250 bottom",
          end: "bottom",
        //   markers: true
        },
      });
      
       tl.fromTo(
          ".contactpage_heading_animation",
          { opacity: 0, y: 80 },
          {
            opacity: 1,
            y: 0,
            duration: 0.8,
             stagger: 0.2,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }, 
        ).fromTo(
          ".contactpage_field_animation",
          { opacity: 0, y: 70 },
          {
            opacity: 1,
            y: 0,
            duration: 0.9,
            stagger: 0.2,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          }, "0"
        )
      return () => {
        tl.kill();
      };
    },
    { scope: container2 },
  );
    return (
        <>
            <div className="map-sec">
               <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3067.1853277421983!2d-75.56381402351712!3d39.757947195470955!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6fd100d7f0e53%3A0xd4d2b468b560754!2sMeridian%20consulting%20services%20LLC!5e0!3m2!1sen!2sin!4v1776750416662!5m2!1sen!2sin" allowfullscreen="" loading="lazy"></iframe>
                    
            </div>
            <div className="contact-area space" ref={container}>
                <div className="container">
                    <div className="contact-page-wrap bg-theme">
                        <div className="row gy-40 align-items-center">
                            <div className="col-lg-4 col-md-6 contact_address_animation">
                                <div className="contact-info">
                                    <div className="contact-info_icon">
                                        <i className="fas fa-phone-alt" />
                                    </div>
                                    <div className="contact-info_details">
                                        <h6 className="contact-info_title">Phone</h6>
                                        <p className="contact-info_text">
                                            <span >(629) 555-0129</span> <br />
                                            <span >01254693326</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 contact_address_animation">
                                <div className="contact-info">
                                    <div className="contact-info_icon">
                                        <i className="fas fa-map-marker-alt" />
                                    </div>
                                    <div className="contact-info_details">
                                        <h6 className="contact-info_title">Location</h6>
                                        <p className="contact-info_text">
                                            24A Trolley Square
Wilmington, DE 19806-3334 <br />
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 contact_address_animation">
                                <div className="contact-info">
                                    <div className="contact-info_icon">
                                        <i className="fas fa-envelope" />
                                    </div>
                                    <div className="contact-info_details">
                                        <h6 className="contact-info_title">Email</h6>
                                        <p className="contact-info_text">
                                            <span>info@meridianitcs.com</span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="space-bottom" ref={container2}>
                <div className="container">
                    <div className="row gy-40 justify-content-between">
                        <div className="col-lg-4">
                            <div className="title-area mb-0">
                                <span className="sub-title contactpage_heading_animation">
                                    <img src="/assets/img/icon/title_left.svg" alt="shape" />
                                    Contact Us
                                </span>
                                <h2 className="sec-title style2 contactpage_heading_animation">Get In Touch</h2>
                                <p className="mb-40 contactpage_heading_animation">
                                   Let’s talk! Your next solution starts with a conversation.{" "}
                                </p>
                                {/* <div className="social-btn style4">
                                    <Link to="#" tabIndex={-1}>
                                        <i className="fab fa-facebook-f" />
                                    </Link>
                                    <Link to="#" tabIndex={-1}>
                                        <i className="fab fa-linkedin-in" />
                                    </Link>
                                    <Link to="#" tabIndex={-1}>
                                        <i className="fab fa-twitter" />
                                    </Link>
                                    <Link to="#" tabIndex={-1}>
                                        <i className="fab fa-instagram" />
                                    </Link>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-8">
                            <div className="contact-form contactpage_field_animation" >
                                <form className="row" onSubmit={formHandlerSubmit}>
                                    <div className='row'>
                                    <div className="col-md-6 form-group contactpage_field_animation">
                                        <input
                                            type="text"
                                            name="Name"
                                            placeholder="Your Name"
                                             className={`form-control style-border ${errors.Name ? "form_err_field" : ""}`}
                {...register("Name", {
                  required: "Name is required",
                  minLength: {
                    value: 2,
                    message: "Name must be at least 2 characters",
                  },
                })}
                                        />
                                          {errors.Name && (
              <p className="error_message">&nbsp;{errors.Name.message}</p>
            )}
                                    </div>
                                  
                                    <div className="col-md-6 form-group contactpage_field_animation">
                                        <input
                                            type="text"
                                            name='Email'
                                            placeholder="Your Email"
                                            className={`form-control style-border ${errors.Email ? "form_err_field" : ""}`}
                {...register("Email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Please enter a valid email address",
                  },
                })}
              />
               {errors.Email && (
              <p className="error_message">&nbsp;{errors.Email.message}</p>
            )}
                                    </div>
                                    </div>
                                    <div className='row '>
                                    
                                    <div className="col-md-6 form-group  ">
                                      <PhoneInput
                      className={`form-control style-border`}
                    name="number"
                    defaultCountry="us"
                    value={phone}
                    onChange={(phone) => setPhone(phone)}
                  />
                                    </div>
                                    <div className="col-md-6 form-group  ">
                                       <input
                                            type="text"
                                            placeholder="Subject"
                                            name="Subject"
                                              className={`form-control style-border ${errors.Subject ? "form_err_field" : ""}`}
                {...register("Subject", {
                  required: "This field is required",
                  minLength: {},
                })}
              />
            {errors.Subject && (
              <p className="error_message">&nbsp;{errors.Subject.message}</p>
            )}
                                    </div>
                                    </div>
                                    <div className="col-12 form-group contactpage_field_animation">
                                        <textarea
                                            placeholder="Message here.."
                                            name="Message"
                                            className={`form-control style-border ${errors.Message ? "form_err_field" : ""}`}
                {...register("Message", {
                  required: "This field is required",
                  minLength: {},
                })}
              ></textarea>
            {errors.Message && (
              <p className="error_message">&nbsp;{errors.Message.message}</p>
            )}
                                    
                                    </div>
                                    <div className="col-12 form-group mb-0 contactpage_field_animation">
                                        <button className="global-btn w-100"  disabled={btnDisabled}> 
                                       {btnDisabled ? "Processing..." : "Submit"} 
                                            
                                            <img src="/assets/img/icon/right-icon.svg" alt="Bizmaster" />
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default ContactInner